import React from 'react';
import CitySearchForm from '../Form/CitySearchForm';

interface DataContext {
  drupalData: Queries.paragraph__search;
}
export default function Search({drupalData}: DataContext): React.JSX.Element {
  return (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-u-border vl-u-highlight-content">
          <h2 className="vl-title vl-title--h2">{drupalData.field_title}</h2>
          <CitySearchForm />
        </div>
      </div>
    </section>
  );
}
